import React, { useState, useRef, useEffect } from "react";
import {
  IPost,
  Person,
  IFeedParam,
  AVBase,
  Feed,
  Post,
  Convo,
} from "../AVCore/AVCore";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { setUser, setEntitydata } from "../Redux/Actions/userActions";
import { setFeeds, setFeedsUpdate } from "../Redux/Actions/feedsAction";
import { Server } from "../Platform/Server";
import * as AV from "../AVCore/AVCore";
import { Loc } from "../App/Loc";
import CustomToast from "../Hooks/useCustomToast";

function useFillFeeds(props, type) {
  const dispatch = useDispatch();
  const textEditRef = useRef<HTMLInputElement>();
  const userfeeds = useSelector(
    (state: RootStateOrAny) => state.feeds.feeds[0],
  );
  const [videos, setvideos] = useState<any>([]);
  const [item, setItem] = useState<any>(
    type === "feeds"
      ? props?.data?.item === undefined
        ? props?.data
        : props?.data?.item
      : type === "convos"
        ? props?.data
        : props?.subitem,
  );
  const [userInfo, setuserInfo] = useState(props?.userInfo);
  const [isAddComment, setIsAddComment] = useState(false);
  const [previewitem, setpreviewitem] = useState<any>([]);
  const [isDeleted, setIsDeleted] = useState(false);
  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );
  const entityDataList = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  /* const { refetch } = useGetFeeds();*/
  const [editItem, setEditItem] = useState<IPost | undefined>(item);
  const [addComment, setAddComment] = useState<any>("");
  const [commentValue, setCommentValue] = useState<any>("");
  const [addRteComment, setAddRteComment] = useState("");
  const [showFilePicker, setShowFilePicker] = useState(false);
  const [showFBEmoji, setShowFBEmoji] = useState(false);
  const [showComment, setShowComment] = useState(false);
  const [showAddComment, setShowAddComment] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [media, setMedia] = useState<any>([]);
  const [commentMedia, setCommentMedia] = useState<any>([]);
  const [gallery, setGallery] = useState<any>([]);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showEditPopups, setShowEditPopups] = useState(false);
  const [showEmoji, setShowEmoji] = useState(false);
  const [showEditPost, setShowEditPost] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [datatype, SetType] = useState<any>([]);
  const [parentId, setParentId] = useState([]);
  const [cmdParent, setCmdParent] = useState<any>([]);
  const [commentTo, setCommentTo] = useState<any>();
  const [images, setImages] = useState<any>([]);
  const [isCommentLoading, setIsCommentLoading] = useState(false);
  const [isLikeLoading, setIsLikeLoading] = useState(false);
  const [showunauthorizedDetails, setshowunauthorizedDetails] = useState(false);
  const [showInsufficientCredits, setShowInsufficientCredits] = useState(false);
  const [replyMore, setIsReplyMore] = useState(false);
  const [editComment, setEditComment] = useState(item?.text);
  const [showEditFilePicker, setShowEditFilePicker] = useState(
    !item?.media?.type,
  );
  const [clickedUrl, setClickedUrl] = useState("");
  const [showConfirmLinkPopup, setShowConfirmLinkPopup] = useState(false);

  const [paySend, setPaySend] = useState<number>(0);
  const [subject, setSubject] = useState<string>("");
  const [estimate, setEstimate] = useState<number | null>(null);
  const [showCreditsPopup, setShowCreditsPopup] = useState(false);
  const [showBoostPostPopup, setShowBoostPostPopup] = useState(false);
  const [sharedPlan, setSharedPlan] = useState<AV.ISharedPlan>();

  const handleAddComment = async (
    commentText,
    showAddComment,
    isFormattedPost,
  ) => {
    if (commentText) {
      //setIsAddComment(showAddComment);

      if (isFormattedPost) {
        setAddComment("");
        setCommentValue("");
        setAddRteComment(commentText);
      } else {
        setAddRteComment("");
        setAddComment(commentText);

        if (!showAddComment) setCommentValue(commentText);
      }
    } else {
      setAddComment("");
      setIsAddComment(false);
      setCommentValue("");
      setAddRteComment("");
    }
  };

  // Replace all base64 images in HTML with uploaded URLs
  async function replaceBase64WithLinks(
    html: string,
    region: string,
  ): Promise<string> {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const imgTags = tempDiv.querySelectorAll("img");

    for (const img of imgTags) {
      const src = img.getAttribute("src");

      // Process only valid Base64 images
      if (!src || !src.startsWith("data:image")) continue;

      // Convert Base64 to File
      const file = base64ToFile2(src, "upload-image.jpg");
      if (!file) continue;

      // Convert to FileList
      const fileList = createFileList([file]);

      // Upload file
      const data = await AV.Media.saveFiles(
        AV.Media.getFormData(fileList),
        region,
      );
      if (!data || data.length === 0) continue;

      // Get uploaded link
      const srclink = AV.Media.getURL(data[0]);
      if (!srclink) continue;

      // Set metadata before saving
      data[0].parent = AV.AVBase.getFk(Person.self());
      //data[0].linkURL = srclink;

      // Save uploaded media
      await AV.Media.saveMedia(data);

      // Replace Base64 src with actual URL
      img.setAttribute("src", srclink);

      // Determine image width dynamically
      const tempImage = document.createElement("img");
      tempImage.src = src;

      await new Promise<void>((resolve) => {
        tempImage.onload = () => {
          const width = tempImage.width;
          const finalWidth = width > 800 ? 800 : width;
          //img.setAttribute("style", `width: ${finalWidth}px;`);
          resolve();
        };
        tempImage.onerror = () => resolve();
      });
    }

    return tempDiv.innerHTML;
  }

  function base64ToFile2(base64: string, filename: string): File {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)?.[1] || "";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  function createFileList(files: File[]): FileList {
    const dataTransfer = new DataTransfer();
    files.forEach((file) => dataTransfer.items.add(file));
    return dataTransfer.files;
  }

  const handlePostComment = async (isFormattedPost: boolean = false) => {
    if (
      (addComment !== undefined && addComment?.trim()?.length > 0) ||
      (addRteComment !== undefined && addRteComment?.trim()?.length > 0) ||
      commentMedia?.length > 0
    ) {
      try {
        setIsCommentLoading(true);
        let post: any = {
          pk: item ? item.pk : previewitem.pk,
          region: item ? item?.region : previewitem.region,
          parentPost: item ? item?.id : previewitem?.id,
        };
        let getpost: any = post;

        if (datatype === "ReplyComment") {
          post.parentPost = parentId;
          post.visibility = cmdParent?.visibility;
        } else {
          post.parentPost = item ? item?.id : previewitem?.id;
          post.visibility = item?.visibility;
        }

        let textContent = isFormattedPost ? addRteComment.trim() : addComment;
        if (isFormattedPost) {
          // Replace base64 images with uploaded links
          textContent = await replaceBase64WithLinks(
            textContent,
            currentUser?.region,
          );
        }
        post.text = textContent;
        post.paySend = textContent?.trim()?.length ? paySend : null;
        post.subject =
          textContent?.trim()?.length && paySend > 0 ? subject : null;
        post.ptype = isFormattedPost ? "H" : null;

        //// Attach metadata (parent + linkURL)
        //for (const mediaItem of commentMedia) {
        //  const srclink = AV.Media.getURL(mediaItem);
        //  if (!srclink) continue;
        //  mediaItem.parent =AV.AVEntity.getFk(item ?? Person.self());
        //  mediaItem.linkURL = srclink;
        //}

        if (commentMedia && commentMedia.length === 0) {
          post.owner = AV.AVEntity.getFk(item ? item : Person.self());
          getpost = await Post.save(post);
          if (getpost === Loc.currentLang.menu.inappropriateErrorMsg) {
            setAddComment("");
            setCommentValue("");
            setAddRteComment("");
            setImages([]);
            setMedia([]);
            setCommentMedia([]);
            setvideos([]);
            setIsCommentLoading(false);
            setShowFilePicker(false);
            setIsAddComment(false);
            let clientError = {
              message: Loc.currentLang.menu.inappropriateErrorMsg,
            };
            CustomToast({ clientError });
            return;
          }
        }

        if (commentMedia && commentMedia.length === 1) {
          post.media = commentMedia[0];
          if (datatype === "ReplyComment") {
            post.parentPost = parentId;
            post.visibility = cmdParent?.visibility;
          } else {
            post.parentPost = item?.id;
            post.visibility = item?.visibility;
          }

          post.owner = AV.AVEntity.getFk(item ? item : Person.self());
          getpost = await Post.save(post);

          if (getpost === Loc.currentLang.menu.inappropriateErrorMsg) {
            setAddComment("");
            setCommentValue("");
            setAddRteComment("");
            setImages([]);
            setMedia([]);
            setCommentMedia([]);
            setvideos([]);
            setIsCommentLoading(false);
            setShowFilePicker(false);
            setIsAddComment(false);
            let clientError = {
              message: Loc.currentLang.menu.inappropriateErrorMsg,
            };
            CustomToast({ clientError });
            return;
          }

          setCommentMedia([]);
          setImages([]);
          setMedia([]);
        }

        if (commentMedia && commentMedia.length > 1) {
          let galleryPost: any = [];
          // post.media = commentMedia[0];
          if (datatype === "ReplyComment") {
            post.parentPost = parentId;
            post.visibility = cmdParent?.visibility;
          } else {
            post.parentPost = item?.id;
            post.visibility = item?.visibility;
          }

          let gallery = { layout: null, Items: [] };
          post.gallery = gallery;
          // let response = await Post.save(post);
          post.id = Server.generateUUID();
          let parentPostId = post?.id;
          let galleryArray: string[] = [];

          for (var i = 0; i < commentMedia.length; i++) {
            let param1: IFeedParam = {
              feed: AVBase.getFk(Person.self()),
              startDate: new Date(0),
              forward: true,
            };

            if (param1?.feed?.id) {
              var post1: any = {
                pk: param1?.feed?.id,
                region: param1?.feed?.region,
              };
              post1.parentPost = parentPostId;
              post1.media = commentMedia[i];
              post1.ptype = "G";
              post1.owner = AV.AVEntity.getFk(item ? item : Person.self());
              let childresponse: any = await Post.save(post1);

              if (
                childresponse === Loc.currentLang.menu.inappropriateErrorMsg
              ) {
                setAddComment("");
                setCommentValue("");
                setAddRteComment("");
                setImages([]);
                setMedia([]);
                setCommentMedia([]);
                setvideos([]);
                setIsCommentLoading(false);
                setShowFilePicker(false);
                setIsAddComment(false);
                let clientError = {
                  message: Loc.currentLang.menu.inappropriateErrorMsg,
                };
                CustomToast({ clientError });
                return;
              }

              galleryArray.push(childresponse?.id);
              galleryPost.push(childresponse);
            }
          }

          post.status = "New";
          post.gallery.items = galleryArray;
          post.owner = AV.AVEntity.getFk(item ? item : Person.self());
          getpost = await Post.save(post);

          if (getpost === Loc.currentLang.menu.inappropriateErrorMsg) {
            setAddComment("");
            setCommentValue("");
            setAddRteComment("");
            setImages([]);
            setMedia([]);
            setCommentMedia([]);
            setvideos([]);
            setIsCommentLoading(false);
            setShowFilePicker(false);
            setIsAddComment(false);
            let clientError = {
              message: Loc.currentLang.menu.inappropriateErrorMsg,
            };
            CustomToast({ clientError });
            return;
          }

          getpost.galleryPost = galleryPost;
          setCommentMedia([]);
          setGallery([]);
          setImages([]);
          setMedia([]);
        }

        let childPost: any = [];
        let childPostIds: any = [];
        if (datatype === "ReplyComment") {
          if (commentTo?.children?.length > 0) childPost = commentTo.children;
          if (commentTo?.posts?.length > 0) childPostIds = commentTo.posts;
          childPost.unshift(getpost);
          childPostIds.unshift(getpost?.id);
          commentTo.children = childPost;
          commentTo.posts = childPostIds;
          setCommentTo(commentTo);
          const updatedParentPost = replaceChildrenInParent(
            commentTo?.id,
            commentTo?.parentPost,
            userfeeds,
            commentTo,
          );
          let exciting = userfeeds?.filter(
            (x) => x.id == updatedParentPost?.id,
          );
          userfeeds[userfeeds.indexOf(exciting[0])] = updatedParentPost;
          dispatch(setFeeds(userfeeds));

          if (previewitem?.id?.trim()?.length > 0) {
            setpreviewitem(previewitem);
          } else {
            setItem(commentTo);
          }

          setAddComment("");
          setCommentValue("");
          setAddRteComment("");
          setIsCommentLoading(false);
          setShowFilePicker(false);
          setIsAddComment(false);
        } else {
          if (
            previewitem?.id?.trim()?.length !== undefined
              ? previewitem?.children
              : item?.children
          )
            childPost =
              previewitem?.id?.trim()?.length !== undefined
                ? previewitem?.children
                : item?.children;
          if (
            previewitem?.id?.trim()?.length !== undefined
              ? previewitem?.children
              : item?.children
          )
            childPostIds =
              previewitem?.id?.trim()?.length !== undefined
                ? previewitem?.posts
                : item?.posts;
          childPost.unshift(getpost);
          childPostIds.unshift(getpost?.id);

          if (previewitem?.id?.trim()?.length !== undefined) {
            previewitem.children = childPost;
            previewitem.posts = childPostIds;
          } else {
            item.children = childPost;
            item.posts = childPostIds;
          }

          if (previewitem?.id?.trim()?.length !== undefined) {
            const updatedParentPost = findParentComment(
              previewitem?.id,
              previewitem?.parentPost,
              userfeeds,
              previewitem,
            );
            let exciting = userfeeds?.filter(
              (x) => x.id == updatedParentPost?.id,
            );
            userfeeds[userfeeds.indexOf(exciting[0])] = updatedParentPost;
            dispatch(setFeeds(userfeeds));

            if (previewitem?.id?.trim()?.length !== undefined) {
              setpreviewitem(previewitem);
            } else {
              setItem(item);
            }

            setItem(item);
            setAddComment("");
            setCommentValue("");
            setAddRteComment("");
            setIsCommentLoading(false);
            setShowFilePicker(false);
            setIsAddComment(false);

            let excitingpost = userfeeds?.filter(
              (x) => x?.id == previewitem?.id,
            );

            if (excitingpost?.length > 0) {
              userfeeds[userfeeds.indexOf(excitingpost[0])] = previewitem;
              dispatch(setFeeds(userfeeds));

              const feedIndex = props?.feedChunks?.findIndex(
                (x) => x?.id === previewitem?.id,
              );
              const updatedFeedChunks = [...props.feedChunks];

              if (feedIndex !== -1) {
                updatedFeedChunks[feedIndex] = previewitem;
              } else {
                updatedFeedChunks.unshift(previewitem);
              }

              //if (previewitem?.id?.trim()?.length === undefined) {
              props.setFeedChunks(updatedFeedChunks);
              //}
            }
          } else {
            const updatedParentPost = replaceChildrenInParent(
              item?.id,
              item?.parentPost,
              userfeeds,
              item,
            );
            let exciting = userfeeds?.filter(
              (x) => x.id == updatedParentPost?.id,
            );
            userfeeds[userfeeds.indexOf(exciting[0])] = updatedParentPost;
            dispatch(setFeeds(userfeeds));

            if (previewitem) {
              setpreviewitem(previewitem);
            } else {
              setItem(item);
            }

            setItem(item);
            setAddComment("");
            setCommentValue("");
            setAddRteComment("");
            setIsCommentLoading(false);
            setShowFilePicker(false);
            setIsAddComment(false);

            let excitingpost = userfeeds?.filter((x) => x?.id == item?.id);
            if (excitingpost?.length > 0) {
              userfeeds[userfeeds.indexOf(excitingpost[0])] = item;
              dispatch(setFeeds(userfeeds));

              const feedIndex = props?.feedChunks?.findIndex(
                (x) => x?.id === item?.id,
              );
              const updatedFeedChunks = [...props.feedChunks];

              if (feedIndex !== -1) {
                updatedFeedChunks[feedIndex] = item;
              } else {
                updatedFeedChunks.unshift(item);
              }

              //if (previewitem?.id?.trim()?.length === undefined) {
              props.setFeedChunks(updatedFeedChunks);
              //}
            }
          }
        }

        if (showFilePicker) setShowFilePicker(!showFilePicker);
        if (showEmoji) setShowEmoji(!showEmoji);
        setIsReplyMore(item?.children[0]?.children?.length > 0 ? true : false);
        setAddComment("");
        setCommentValue("");
        setAddRteComment("");
        setImages([]);
        setMedia([]);
        setCommentMedia([]);
        setvideos([]);
        setIsCommentLoading(false);
        setShowFilePicker(false);
        setIsAddComment(false);

        if (paySend > 0) {
          setTimeout(() => {
            creditsUpdateAfterPublish();
          }, 500);
        }

        setPaySend(0);
        setSubject("");
        setEstimate(0);
      } catch (ex) {
        setIsCommentLoading(false);
        console.log("error_message : " + ex);
      }
    }
  };

  const creditsUpdateAfterPublish = async () => {
    const entity: any = item?.owner ?? currentUser;
    const fk: AV.IFK = AV.AVEntity.getFk(entity ?? currentUser);
    let finalFk: AV.IFK = item?.owner ?? fk;
    if (item?.owner?.type === "Person") {
      finalFk =
        currentUser?.id !== item?.owner.id
          ? AV.AVEntity.getFk(currentUser)
          : item?.owner;
    }

    // Update current user credits
    if (
      finalFk?.id === currentUser?.id &&
      currentUser?.plan &&
      !currentUser?.plan?.shared
    ) {
      dispatch(
        setUser({
          ...currentUser,
          plan: {
            ...currentUser.plan,
            credits: (currentUser.plan.credits || 0) - (estimate ?? 0),
          },
        }),
      );
    }

    // Shared Plan
    if (sharedPlan && sharedPlan?.plan) {
      setSharedPlan?.({
        ...sharedPlan,
        plan: {
          ...sharedPlan.plan,
          credits: (sharedPlan.plan.credits || 0) - (estimate ?? 0),
        },
      });

      const updatedList = [...entityDataList];
      const index = updatedList.findIndex((x) => x?.id === sharedPlan?.id);

      if (index !== -1) {
        const current = updatedList[index];

        updatedList[index] = {
          ...current,
          plan: {
            ...current?.plan,
            credits: (current?.plan?.credits || 0) - (estimate ?? 0),
          },
        };
      }

      dispatch(setEntitydata(updatedList));
    }

    // Update entity list credits
    if (
      finalFk?.id === currentUser?.id &&
      currentUser?.plan &&
      !currentUser?.plan?.shared
    ) {
      const updatedList = [...entityDataList];
      const index = updatedList.findIndex((x) => x?.id === currentUser?.id);

      if (index !== -1) {
        const current = updatedList[index];

        updatedList[index] = {
          ...current,
          plan: {
            ...current?.plan,
            credits: (current?.plan?.credits || 0) - (estimate ?? 0),
          },
        };
      }

      dispatch(setEntitydata(updatedList));
    }

    //try {
    //  const entityDataAPI: AV.IAVEntity | null = await AV.AVEntity.get(finalFk);

    //  if (entityDataAPI) {
    //    if (entityDataAPI.type === "Person") {
    //      dispatch(setUser(entityDataAPI));
    //    }

    //    const index = entityDataList?.findIndex(
    //      (x) => x?.id === entityDataAPI.id,
    //    );
    //    if (index !== -1) {
    //      entityDataList[index] = entityDataAPI;
    //    } else {
    //      entityDataList?.push(entityDataAPI);
    //    }

    //    dispatch(setEntitydata([...entityDataList]));
    //  }
    //} catch (e) {
    //  console.error("Failed to update entity after publish:", e);
    //}
  };

  const handleConvoPostComment = async (item) => {
    let post = Convo.createConvoPost(item);
    post.text = addComment;
    post.media = commentMedia;
    post.parentPost = item?.id;
    post = await Post.saveConvo(post);
    setIsAddComment(!isAddComment);
  };

  const replacedeleteChildrenInParent = (
    postId,
    parentpostId,
    nestedData,
    newChildren,
  ) => {
    for (const item of nestedData) {
      if (item.id === parentpostId) {
        if (!item?.children) item.children = [];
        let val = item.children.filter((x) => x?.id !== postId);
        item.children = val;
        item.posts = item.posts.filter((x) => x !== postId);
        return item;
      }
      if (item.children && item.children.length > 0) {
        // Continue searching in children
        const updatedChild = replacedeleteChildrenInParent(
          postId,
          parentpostId,
          item.children,
          newChildren,
        );
        if (updatedChild) {
          return item; // Return the parent with updated children
        }
      }
      if (item?.galleryPost && item.galleryPost.length > 0) {
        // Continue searching in children
        const updatedChild = replacedeleteChildrenInParent(
          postId,
          parentpostId,
          item.galleryPost,
          newChildren,
        );
        if (updatedChild) {
          return item; // Return the parent with updated children
        }
      }
    }
    return null; // Parent post not found
  };

  useEffect(() => {
    setItem(
      type === "feeds"
        ? props?.data?.item === undefined
          ? props?.data
          : props?.data?.item
        : type === "convos"
          ? props?.data
          : props?.subitem,
    );
  }, [props]);

  const replaceChildrenInParent = (
    postId,
    parentpostId,
    nestedData,
    newChildren,
  ) => {
    for (const item of nestedData) {
      if (item.id === parentpostId) {
        if (!item?.children) item.children = [];
        let val = item.children.filter((x) => x?.id == postId);
        if (val?.length > 0)
          item.children[item.children.indexOf(val[0])] = newChildren;
        else item.children.push(newChildren);
        return item;
      }

      if (item.children && item.children.length > 0) {
        // Continue searching in children
        const updatedChild = replaceChildrenInParent(
          postId,
          parentpostId,
          item.children,
          newChildren,
        );
        if (updatedChild) {
          return item; // Return the parent with updated children
        }
      }
      if (item?.galleryPost && item.galleryPost.length > 0) {
        // Continue searching in children
        const updatedChild = replaceChildrenInParent(
          postId,
          parentpostId,
          item.galleryPost,
          newChildren,
        );
        if (updatedChild) {
          return item; // Return the parent with updated children
        }
      }
    }
    return null; // Parent post not found
  };

  const findParentPost = (postId, parentpostId, nestedData, newChildren) => {
    for (const item of nestedData) {
      if (item.id === parentpostId) {
        return item;
      }

      if (item.children && item.children.length > 0) {
        // Continue searching in children
        const updatedChild = replaceChildrenInParent(
          postId,
          parentpostId,
          item.children,
          newChildren,
        );
        if (updatedChild) {
          return item; // Return the parent with updated children
        }
      }
      if (item?.galleryPost && item.galleryPost.length > 0) {
        // Continue searching in children
        const updatedChild = replaceChildrenInParent(
          postId,
          parentpostId,
          item.galleryPost,
          newChildren,
        );
        if (updatedChild) {
          return item; // Return the parent with updated children
        }
      }
    }
    return null; // Parent post not found
  };

  const findParentComment = (postId, parentpostId, nestedData, newChildren) => {
    for (const item of nestedData) {
      if (item.id === parentpostId) {
        return item;
      }
    }
    return null; // Parent post not found
  };

  const handleLikePost = async (post, type) => {
    setIsLikeLoading(true);

    // Check if current user has already liked/reacted with the same type
    const existingPost = post?.impressions?.filter(
      (x: any) => x?.id === currentUser?.id && x?.impression === type,
    );

    if (existingPost?.length > 0) {
      // If already reacted with same type, remove it instead
      handleremoveLike(post, type);
      return;
    }

    try {
      // Filter out current user's old impression (if any)
      const updatedImpressions =
        post.impressions?.filter((imp) => imp.id !== currentUser?.id) || [];

      // Add new impression
      const newImpression: any = {
        id: currentUser?.id || "",
        pk: currentUser?.pk || "",
        region: currentUser?.region || "",
        type: currentUser?.type || "",
        title: currentUser?.name || "",
        impression: type,
        date: new Date().toISOString(),
      };
      updatedImpressions.push(newImpression);

      // Create optimistic version of the post
      const optimisticPost = { ...post, impressions: updatedImpressions };

      //// Update local states (preview & current item)
      //setItem(optimisticPost);
      //setpreviewitem(optimisticPost);

      // Update cache states
      const feedsClone = [...userfeeds];
      const feedChunksClone = [...(props?.feedChunks || [])];

      // Update optimistic cache
      dispatch(setFeeds(updatePostInLists(feedsClone, optimisticPost)));
      if (feedChunksClone.length > 0) {
        props?.setFeedChunks?.(
          updatePostInLists(feedChunksClone, optimisticPost),
        );
      } else {
        props?.setFeedChunks?.(updatePostInLists(feedsClone, optimisticPost));
      }

      // Call API to add reaction
      const updatedPost = await Post.addImpression(post, type);

      // Update with actual data from API response
      dispatch(setFeeds(updatePostInLists(feedsClone, updatedPost)));
      if (feedChunksClone.length > 0) {
        props?.setFeedChunks?.(updatePostInLists(feedChunksClone, updatedPost));
      } else {
        props?.setFeedChunks?.(updatePostInLists(feedsClone, updatedPost));
      }
    } catch (err) {
      console.error("Error impression post:", err);
    } finally {
      setIsLikeLoading(false);
    }
  };

  // Utility function to update a post or child post within a list
  const updatePostInLists = (list, updatedItem) => {
    const parentIndex = list.findIndex((x) => x.id === updatedItem?.parentPost);
    const isChildPost = parentIndex !== -1;

    if (isChildPost) {
      // If the updated item is a child post, update it inside its parent
      const parentPost = { ...list[parentIndex] };

      const childIndex = parentPost.children?.findIndex(
        (x) => x?.id === updatedItem?.id,
      );
      if (childIndex !== undefined && childIndex !== -1) {
        parentPost.children[childIndex] = updatedItem;
      }

      const galleryIndex = parentPost.galleryPost?.findIndex(
        (x) => x?.id === updatedItem?.id,
      );
      if (galleryIndex !== undefined && galleryIndex !== -1) {
        parentPost.galleryPost[galleryIndex] = updatedItem;
      }

      list[parentIndex] = parentPost;
    } else {
      // If the item is a top-level post, update it directly
      const postIndex = list.findIndex((x) => x.id === updatedItem?.id);
      if (postIndex !== undefined && postIndex !== -1) {
        const updatedPostItem = {
          ...updatedItem,
          children: (list[postIndex] as any).children ?? updatedItem.children,
          galleryPost:
            (list[postIndex] as any).galleryPost ?? updatedItem.galleryPost,
        };
        list[postIndex] = updatedPostItem;
      }
    }

    return list;
  };

  const handleremoveLike = async (post, type) => {
    setIsLikeLoading(true);

    try {
      // Remove the impression of the current user with the matching type
      const updatedImpressions =
        post.impressions?.filter(
          (imp) => !(imp.id === currentUser?.id && imp.impression === type),
        ) || [];

      // Create optimistic version of the post
      const optimisticPost = { ...post, impressions: updatedImpressions };

      //// Update local states (preview & current item)
      //setItem(optimisticPost);
      //setpreviewitem(optimisticPost);

      // Optimistically update the UI
      const feedsClone = [...userfeeds];
      const feedChunksClone = [...(props?.feedChunks || [])];

      // Update optimistic cache
      dispatch(setFeeds(updatePostInLists(feedsClone, optimisticPost)));
      if (feedChunksClone.length > 0) {
        props?.setFeedChunks?.(
          updatePostInLists(feedChunksClone, optimisticPost),
        );
      } else {
        props?.setFeedChunks?.(updatePostInLists(feedsClone, optimisticPost));
      }

      // Call API to remove impression
      const updatedPost = await Post.removeImpression(post, type);

      // Update with actual data from API response
      dispatch(setFeeds(updatePostInLists(feedsClone, updatedPost)));
      if (feedChunksClone.length > 0) {
        props?.setFeedChunks?.(updatePostInLists(feedChunksClone, updatedPost));
      } else {
        props?.setFeedChunks?.(updatePostInLists(feedsClone, updatedPost));
      }
    } catch (err) {
      console.error("Error removing impression:", err);
    } finally {
      setIsLikeLoading(false);
    }
  };

  const onEmojiClick = (
    emojiObject: { native: string },
    isFormattedPost?: boolean,
    rteValue?: string,
  ) => {
    const emoji = emojiObject?.native;
    if (!emoji) return;

    if (isFormattedPost) {
      // Update RTE value
      setAddRteComment(rteValue ?? "");
    } else {
      // Insert emoji into plain text input
      const newVal = commentValue ? commentValue + emoji : emoji;
      setCommentValue(newVal);
      setAddComment(newVal);
    }

    setShowEmoji(false);
  };

  const handleUpdatePost = async (e: any) => {
    e.preventDefault();
    const text = textEditRef?.current?.value || "";
    if (!text || text.length < 1) return;
    if (commentMedia?.id !== "") {
      item.media = commentMedia;
    }
    item.text = text;
    await Post.save(item);
    setGallery([]);
    setCommentMedia({});
    setShowEditPost(!showEditPost);
  };

  const handleFilePicker = () => {
    setCommentMedia([]);
    setGallery([]);
    setImages([]);
    setMedia([]);
    setShowFilePicker(!showFilePicker);
    setShowEmoji(false);
  };

  const handleslideChange = () => {
    setCommentMedia([]);
    setGallery([]);
    setImages([]);
    setMedia([]);
    setShowFilePicker(false);
  };

  const handleimgCancel = () => {
    setCommentMedia([]);
    setGallery([]);
    setImages([]);
    setMedia([]);
    setShowFilePicker(false);
  };

  const handleEmojiPicker = () => {
    setShowFBEmoji(!showFBEmoji);
  };

  const handleComment = () => {
    setShowComment(!showComment);
  };

  const getImageGalleryFromFilePickerCreateConvo = (filePickerData: any) => {};

  const handleReplyPost = (item) => {
    setCommentTo(item);
    setAddComment("");
    setImages([]);
    setIsAddComment(!isAddComment);
  };

  const handleEditPopup = async (item) => {
    setShowEditPopups(!showEditPopups);
    setShowEditPopup(!showEditPopup);
    setEditItem(item);
  };

  const handleDeletePost = async (item) => {
    Post.delete(item);
    let val = userfeeds?.filter((x) => x.id === item.id);
    if (val?.length > 0) {
      val[0].status = "Deleted";
      userfeeds[userfeeds.indexOf(val[0])] = val[0];
      dispatch(setFeeds(userfeeds));
      dispatch(setFeedsUpdate(true));
    } else {
      const updatedParentPost = replacedeleteChildrenInParent(
        item?.id,
        item?.parentPost,
        userfeeds,
        item,
      );
      if (updatedParentPost) {
        let exciting = userfeeds?.filter((x) => x.id == updatedParentPost?.id);
        userfeeds[userfeeds.indexOf(exciting[0])] = updatedParentPost;
        dispatch(setFeeds(userfeeds));
        dispatch(setFeedsUpdate(true));
      }
    }
    setIsDeleted(true);
    setShowEditPopup(!showEditPopup);
    setShowEditPopups(!showEditPopups);
    setShowDetails(false);
    setpreviewitem([]);
  };

  const HandleRejected = async (item) => {
    Post.delete(item);
    let val = userfeeds?.filter((x) => x.id === item.id);
    if (val?.length > 0) {
      val[0].status = "Deleted";
      userfeeds[userfeeds.indexOf(val[0])] = val[0];
      dispatch(setFeeds(userfeeds));
      dispatch(setFeedsUpdate(true));
    } else {
      const updatedParentPost = replacedeleteChildrenInParent(
        item?.id,
        item?.parentPost,
        userfeeds,
        item,
      );
      if (updatedParentPost) {
        let exciting = userfeeds?.filter((x) => x.id == updatedParentPost?.id);
        userfeeds[userfeeds.indexOf(exciting[0])] = updatedParentPost;
        dispatch(setFeeds(userfeeds));
        dispatch(setFeedsUpdate(true));
      }
    }
    setIsDeleted(true);
    setShowEditPopup(!showEditPopup);
    setShowEditPopups(!showEditPopups);
    setShowDetails(false);
    setpreviewitem([]);
  };

  const handleReportPost = async (item) => {
    Post.Report(item);
    item.modStatus = "NR";
    let val = userfeeds?.filter((x) => x.id === item.id);
    if (val?.length > 0) {
      let feeds = userfeeds?.filter((x) => x.id !== item.id);
      dispatch(setFeeds(feeds));
    } else {
      if (val?.length > 0) {
        val[0].modStatus = "NR";
        userfeeds[userfeeds.indexOf(val[0])] = val[0];
        dispatch(setFeeds(userfeeds));
        dispatch(setFeedsUpdate(true));
      } else {
        const updatedParentPost = replacedeleteChildrenInParent(
          item?.id,
          item?.parentPost,
          userfeeds,
          item,
        );
        if (updatedParentPost) {
          let exciting = userfeeds?.filter(
            (x) => x.id == updatedParentPost?.id,
          );
          userfeeds[userfeeds.indexOf(exciting[0])] = updatedParentPost;
          dispatch(setFeeds(userfeeds));
          dispatch(setFeedsUpdate(true));
        }
      }
    }
    setIsDeleted(true);
    setShowEditPopup(!showEditPopup);
    setShowEditPopups(!showEditPopups);
  };

  const handleEditPost = async (item) => {
    setShowModal(!showModal);
    if (!item?.parentPost) setShowEditPopup(!showEditPopup);
    setEditItem(item);
  };

  const handleAcceptedPost = async (item) => {
    await Post.AcceptReview(item);
    item.modStatus = "RA";
    let excitingpost = userfeeds?.filter((x) => x?.id == item?.id);
    userfeeds[userfeeds.indexOf(excitingpost[0])] = item;
    dispatch(setFeeds(userfeeds));
    setShowEditPopup(!showEditPopup);
  };

  const handleEditComment = async (commentText) => {
    if (commentText) {
      setEditComment(commentText);
    } else {
      setEditComment("");
    }
  };

  const handleEditFilePicker = () => {
    setShowEditFilePicker(!showEditFilePicker);
  };

  const updateFeeds = (updatedPostItem: AV.IPost) => {
    // Update local feedChunks (from props)
    if (props?.feedChunks?.length) {
      const feedIndex = props.feedChunks.findIndex(
        (x) => x?.id === updatedPostItem?.id,
      );

      if (feedIndex !== -1) {
        const updatedFeedChunks = [...props.feedChunks];
        updatedFeedChunks[feedIndex] = updatedPostItem;
        props.setFeedChunks(updatedFeedChunks);
      }
    }

    // Update global Redux feeds
    if (userfeeds?.length) {
      const userFeedIndex = userfeeds.findIndex(
        (x) => x?.id === updatedPostItem?.id,
      );

      if (userFeedIndex !== -1) {
        const updatedUserFeeds = [...userfeeds];
        updatedUserFeeds[userFeedIndex] = updatedPostItem;
        dispatch(setFeeds(updatedUserFeeds));
      }
    }
  };

  const updateParentFeeds = (updatedPostItem: AV.IPost, parentId: string) => {
    const parentPost = userfeeds?.find((x) => x?.id === parentId);
    if (parentPost) {
      const childIndex = parentPost.children.findIndex(
        (x) => x?.id === updatedPostItem?.id,
      );
      if (childIndex !== -1) {
        const updatedParentPost = {
          ...parentPost,
          children: [...parentPost.children],
        };
        updatedParentPost.children[childIndex] = updatedPostItem;

        if (props?.feedChunks?.length) {
          const parentFeedIndex = props.feedChunks.findIndex(
            (x) => x?.id === parentId,
          );
          if (parentFeedIndex !== -1) {
            const updatedFeedChunks = [...props.feedChunks];
            updatedFeedChunks[parentFeedIndex] = updatedParentPost;
            props.setFeedChunks(updatedFeedChunks);
          }
        } else if (props?.data?.feedChunks?.length) {
          const parentFeedIndex = props.data.feedChunks.findIndex(
            (x) => x?.id === parentId,
          );
          if (parentFeedIndex !== -1) {
            const updatedFeedChunks = [...props.data.feedChunks];
            updatedFeedChunks[parentFeedIndex] = updatedParentPost;
            props.data.setFeedChunks(updatedFeedChunks);
          }
        }

        const parentIndex = userfeeds?.findIndex((x) => x?.id === parentId);
        if (parentIndex !== -1) {
          const updatedUserFeeds = [...userfeeds];
          updatedUserFeeds[parentIndex] = updatedParentPost;
          dispatch(setFeeds(updatedUserFeeds));
        }
      }
    }
  };

  const handleTranslateText = async (item: AV.IPost) => {
    const userLang = currentUser?.preferences?.lang;
    const isAlreadyTrans = item?.trans?.some((x) => x.lang === userLang);

    // If translation already exists
    if (isAlreadyTrans) {
      const updatedPostItem = { ...item, isTranslateText: true };

      if (item?.parentPost) {
        updateParentFeeds(updatedPostItem, item.parentPost);
      } else {
        updateFeeds(updatedPostItem);
      }

      if (previewitem?.id === updatedPostItem?.id) {
        setpreviewitem(updatedPostItem);
      }
      setItem(updatedPostItem);
      setShowEditPopup(false);

      return;
    }

    // Otherwise, request translation
    const fk: AV.IFK = {
      id: item?.id,
      pk: item.pk,
      region: item?.region,
      type: item?.type,
    };

    try {
      const postItem = await AV.Post.translate(fk);
      if (!postItem) return;

      const updatedPostItem = {
        ...postItem,
        isTranslateText: true,
        children: (item as any).children ?? (postItem as any).children,
        galleryPost: (item as any).galleryPost ?? (postItem as any).galleryPost,
      };

      if (item?.parentPost) {
        updateParentFeeds(updatedPostItem, item.parentPost);
      } else {
        updateFeeds(updatedPostItem);
      }

      if (previewitem?.id === updatedPostItem?.id) {
        setpreviewitem(updatedPostItem);
      }
      setItem(updatedPostItem);
      setShowEditPopup(false);
    } catch (error) {
      console.error("Translation Error:", error);
    }
  };

  const handleShowOriginalText = (item) => {
    const updatedPostItem = { ...item, isTranslateText: !item.isTranslateText };

    if (item?.parentPost) {
      updateParentFeeds(updatedPostItem, item.parentPost);
    } else {
      updateFeeds(updatedPostItem);
    }

    if (previewitem?.id === updatedPostItem?.id) {
      setpreviewitem(updatedPostItem);
    }
    setItem(updatedPostItem);
    setShowEditPopup(false);
  };

  return {
    item,
    userInfo,
    setuserInfo,
    setItem,
    isAddComment,
    setIsAddComment,
    addComment,
    setAddComment,
    commentValue,
    setCommentValue,
    addRteComment,
    setAddRteComment,
    showFilePicker,
    setShowFilePicker,
    media,
    setMedia,
    gallery,
    setGallery,
    handleAddComment,
    handlePostComment,
    handleimgCancel,
    handleLikePost,
    showEmoji,
    handleEmojiPicker,
    handleConvoPostComment,
    setShowEmoji,
    showModal,
    handleremoveLike,
    setShowModal,
    datatype,
    SetType,
    parentId,
    setParentId,
    setCommentTo,
    handleFilePicker,
    showComment,
    setShowComment,
    handleComment,
    getImageGalleryFromFilePickerCreateConvo,
    handleReplyPost,
    onEmojiClick,
    showEditPopup,
    setShowFBEmoji,
    showFBEmoji,
    setShowEditPopup,
    handleEditPopup,
    handleDeletePost,
    //handleReportPost,
    handleEditPost,
    handleAcceptedPost,
    showEditPost,
    setShowEditPost,
    textEditRef,
    handleEditComment,
    handleUpdatePost,
    editComment,
    showEditFilePicker,
    handleEditFilePicker,
    isDeleted,
    showDetails,
    setShowDetails,
    showunauthorizedDetails,
    setshowunauthorizedDetails,
    showInsufficientCredits,
    setShowInsufficientCredits,
    images,
    setImages,
    setIsCommentLoading,
    isCommentLoading,
    commentMedia,
    setCommentMedia,
    editItem,
    setEditItem,
    previewitem,
    setpreviewitem,
    setShowEditPopups,
    showEditPopups,
    videos,
    setvideos,
    handleslideChange,
    isLikeLoading,
    HandleRejected,
    cmdParent,
    setCmdParent,
    handleTranslateText,
    handleShowOriginalText,
    showAddComment,
    setShowAddComment,
    clickedUrl,
    setClickedUrl,
    showConfirmLinkPopup,
    setShowConfirmLinkPopup,
    paySend,
    setPaySend,
    subject,
    setSubject,
    estimate,
    setEstimate,
    showBoostPostPopup,
    setShowBoostPostPopup,
    showCreditsPopup,
    setShowCreditsPopup,
    sharedPlan,
    setSharedPlan,
  };
}

export default useFillFeeds;
